import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { DirectPlan } from '../../models/direct-subscription.interface';
import { DirectSubscriptionService } from '../../services/direct-subscription.service';
import { PayoutMethod, PayoutMethodProvider, PayoutMethodsService } from '../../services/payout-methods.service';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-switch-plan-interstitial',
  templateUrl: './dialog-switch-plan-interstitial.component.html',
  styleUrls: ['./dialog-switch-plan-interstitial.component.scss'],
})
export class DialogSwitchPlanInterstitialComponent implements OnInit {
  loading: boolean = true;

  DirectPlan = DirectPlan;
  directSub$ = this.directSubService.subscriptionStatus$;
  switching: boolean = false;

  needsToAddStripeAccount: boolean = false;
  needsToAddAdyenAccount: boolean = false;

  payoutMethods: PayoutMethod[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogSwitchPlanInterstitialComponent>,
    private directSubService: DirectSubscriptionService,
    private payoutMethodsService: PayoutMethodsService,
    @Inject(MAT_DIALOG_DATA) public dialogData: { plan: DirectPlan }
  ) { }

  ngOnInit(): void {
    this.fetchExistingPayoutMethodsData();
  }

  fetchExistingPayoutMethodsData() {
    // We want to fetch data about existing payout methods, to know whether the user needs to add a payout method before they can switch
    this.payoutMethodsService.fetchPayoutMethods().subscribe((res) => {
      this.loading = false;

      this.payoutMethods = res;

      // The plan they are switching to
      const plan = this.dialogData.plan;

      // Need to check they have Adyen for Premium
      if (plan === DirectPlan.Premium) {
        this.needsToAddAdyenAccount = !this.payoutMethods.some((payoutMethod) => {
          return payoutMethod.provider === PayoutMethodProvider.ADYEN && payoutMethod.all_properties;
        });
      }

      // Need to check they have Stripe for Basic
      if (plan === DirectPlan.Basic) {
        this.needsToAddStripeAccount = !this.payoutMethods.some((payoutMethod) => {
          return payoutMethod.provider === PayoutMethodProvider.STRIPE_OAUTH && payoutMethod.all_properties;
        });
      }
    });
  }

  switchPlan(isTrialling: boolean, newPlan: DirectPlan) {
    this.switching = true;

    this.directSubService.switchPlan(isTrialling, newPlan).subscribe((res) => {
      this.switching = false;
      this.dialogRef.close();
      window.location.reload();
    });
  }
}
